import { authSelectors } from "features/auth/authSlice";
import { fetchUserImages, ImageGroup } from "features/editor/sidebar/image/imageCollections";
import { ImagePicker } from "features/editor/sidebar/image/ImagePicker";
import { useAppSelector } from "lib/redux/hooks";
import { useCallback } from "react";

export interface LabelImagePickerProps {
    url: string|null;
    onChange: (url: string|null) => void;
    aspect?: number;
}

export const LabelImagePicker = (props: LabelImagePickerProps) => {
    const userId = useAppSelector(authSelectors.customer);

    const fetchImages = useCallback(async (): Promise<ImageGroup[]> => {
        if (userId == null) {
            return Promise.resolve([]);
        } else {
            const images = await fetchUserImages(userId, 'label')
            return [{
                name: "Images",
                images: images
            }];
        }
    }, [userId]);
    
    if (!userId) return null;

    return (
        <ImagePicker
            images={fetchImages}
            currentImage={props.url ?? null}
            onPick={url=>props.onChange(url)}
            allowClear={true}
            upload={{
                allowResize: true,
                resizeAspect: props.aspect,
                userId: userId,
                collection: 'label'
            }}
        />
    );
}